import React from "react";

/**
 * Branded full-screen loader shown while auth refreshes / a route resolves.
 * Uses the app-chrome dark gradient so it blends seamlessly out of the
 * native splash screen (also slate-900), with a glowing spinning ring, the
 * iG mark, the wordmark and animated dots — so the first paint already feels
 * like the app rather than a bare spinner.
 */
export default function FullScreenLoader() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-gradient-to-b from-[#131a2e] to-[#0b1120] relative overflow-hidden">
      {/* soft glow */}
      <div className="pointer-events-none absolute -top-24 -left-16 w-72 h-72 rounded-full bg-indigo-500/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-16 w-80 h-80 rounded-full bg-blue-500/20 blur-3xl" />

      <div className="relative w-24 h-24 grid place-items-center">
        {/* spinning ring */}
        <div className="absolute inset-0 rounded-full border-4 border-white/10 border-t-indigo-400 animate-spin" />
        {/* logo mark */}
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-indigo-500 to-blue-600 grid place-items-center text-white text-lg font-black shadow-lg shadow-indigo-500/40 animate-pulse">
          iG
        </div>
      </div>

      <img src="/assets/ig_h_white.png" alt="iGROWth" className="h-7 w-auto opacity-90" />

      {/* bouncing dots */}
      <div className="flex items-center gap-1.5">
        <span className="w-2 h-2 rounded-full bg-indigo-300 animate-bounce" style={{ animationDelay: "0ms" }} />
        <span className="w-2 h-2 rounded-full bg-indigo-300 animate-bounce" style={{ animationDelay: "150ms" }} />
        <span className="w-2 h-2 rounded-full bg-indigo-300 animate-bounce" style={{ animationDelay: "300ms" }} />
      </div>
    </div>
  );
}
